import React, {Component} from 'react';

import PanelNovedad from '../../../../Common/Components/PanelNovedad';
import ModalHistorialModificaciones from '../../HistorialModificacionCuenta/ModalHistorialModificaciones';

class DatosIntegrante extends Component {
    constructor(props) {
        super(props);
        this.state = {  };
    }
    render() {

        const {data, integrante, permisos} = this.props;
        const modalModificaciones = <ModalHistorialModificaciones seccion={"IntegrantesCuenta"} listaModificaciones={data.IntegrantesCuenta.modificacionesCuenta} openModal={this.props.actions.getLogModificaciones}  />
        
        return (
            <div className="contenedorDatosIntegranteIndividualCuenta">
                    <div className='paddingSides procesoColumnRight alignItemsCenter'>
                            <h2 className=' tituloIntegrantesCuentaModif'>
                                Edición de datos
                            </h2>
                            <div>
                                <label onClick={()=>this.props.verDatosIntegrante(null)} className="ti-close clickable botonCerrarDatosIntegrantes"></label>
                            </div>
                    </div>
                    <div className='bottom-separator bottom-separator-xs separadorTituloIntegrantesCuentaModif'></div>
                    <div className='paddingSides contenedorDatosIntegranteIndividualCuenta'>
                        <div className='divNovedadIntegranteCuenta'>
                            <PanelNovedad 
                            aceptarCambios={this.props.aceptarCambios} 
                            nombreCampo={"DENOM_TARJ"} /*confirmar el codigo de novedad*/
                            data={data.IntegrantesCuenta}
                            tituloCampo={"Denominación"} 
                            valorActualDescripcion={integrante.DenominacionTarjeta} 
                            valorActual={integrante.DenominacionTarjeta}
                            novedad={(this.props.novedades || []).filter(n => n.NovedadCampoCodigo == "DENOM_TARJ" && ![3,5,6,7].some(e=>e==n.NovedadEstadoId))} 
                            cambiarEstadoNovedad={this.props.cambiarEstadoNovedad}
                            opciones={null/* es campo con input, no lleva opciones*/}
                            codigoCampo={"DENOM_TARJ"}
                            selectCombo={this.props.actions.selectValorCampo/* ver si sirve para actualizar valor input */}
                            funcionEdicion={this.props.actions.editandoCampoCuenta}
                            guardarNovedad={this.props.actions.guardarNovedad}
                            cambiarEstadoNovedad={this.props.actions.actualizarNovedadEstado}
                            logHistorialCambios={this.props.actions.getLogModificaciones}
                            componenteModificaciones={modalModificaciones}
                            logModificacionesAbierto={data.IntegrantesCuenta.viendoModificacionesCampo == "DENOM_TARJ"}
                            seccion={"IntegrantesCuenta"}
                            esInput={true}
                            tarjetaId={integrante.TarjetaCreditoId ? integrante.TarjetaCreditoId : null}
                            funcionLimpiarStore={this.props.actions.limpiarStoreComponente}
                            muestraBotonHistorial={this.props.novedades && this.props.novedades.some(n => n.NovedadCampoCodigo == "DENOM_TARJ")}
                            permisoModificacion={permisos.permisoModificacionIntegrantes}
                            permisoConfirmacion={permisos.permisoConfirmacionIntegrantes}
                            />
                        </div>
                        <div className='divNovedadIntegranteCuenta'>
                            <PanelNovedad 
                            aceptarCambios={this.props.aceptarCambios} 
                            nombreCampo={"CRLIN_TARJ"} /*confirmar el codigo de novedad*/
                            data={data.IntegrantesCuenta}
                            tituloCampo={"Cuarta Línea"} 
                            valorActualDescripcion={integrante.DenominacionCuartaLinea} 
                            valorActual={integrante.DenominacionCuartaLinea}
                            novedad={(this.props.novedades || []).filter(n => n.NovedadCampoCodigo == "CRLIN_TARJ" && ![3,5,6,7].some(e=>e==n.NovedadEstadoId))} 
                            cambiarEstadoNovedad={this.props.cambiarEstadoNovedad}
                            opciones={null/* es campo con input, no lleva opciones*/}
                            codigoCampo={"CRLIN_TARJ"}
                            selectCombo={this.props.actions.selectValorCampo/* ver si sirve para actualizar valor input */}
                            funcionEdicion={this.props.actions.editandoCampoCuenta}
                            guardarNovedad={this.props.actions.guardarNovedad}
                            cambiarEstadoNovedad={this.props.actions.actualizarNovedadEstado}
                            logHistorialCambios={this.props.actions.getLogModificaciones}
                            componenteModificaciones={modalModificaciones}
                            logModificacionesAbierto={data.IntegrantesCuenta.viendoModificacionesCampo == "CRLIN_TARJ"}
                            seccion={"IntegrantesCuenta"}
                            esInput={true}
                            tarjetaId={integrante.TarjetaCreditoId ? integrante.TarjetaCreditoId : null}
                            funcionLimpiarStore={this.props.actions.limpiarStoreComponente}
                            muestraBotonHistorial={this.props.novedades && this.props.novedades.some(n => n.NovedadCampoCodigo == "CRLIN_TARJ")}
                            permisoModificacion={permisos.permisoModificacionIntegrantes}
                            permisoConfirmacion={permisos.permisoConfirmacionIntegrantes}
                            />
                        </div>
                        <div>
                            <div className=" no-padding">
                                <label className="label-primary">Vínculo</label>
                                {<div className=" bottom-separator-xs">
                                    <div className="camposEdicionCuenta edit-panel-lapiz-new">
                                        <div className=" camposEdicionCuenta color-azul-claro">{"Titular" /*M O C K E A D O*/}</div>
                                    </div>
                                </div>}             
                            </div>                  
                        </div>
                    </div>
                    <div className='paddingSides footerDatosIntegrantesCuenta'>
                        <p>Si modifica algún dato, tomará efecto en la próxima impresión de plástico que se realice.</p>
                        <p>Puede solicitar la <span>reimpresión</span> ahora si así lo desea.</p>
                    </div>
                </div>
        );
    }
}

export default DatosIntegrante;